module.exports = __webpack_public_path__ + "img/tube.d0fc9f0a.svg";